import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl44AutoValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .max(
        new Date(),
        t(
          "Η ημερομηνία απόφασης οργάνου δεν μπορεί να είναι μεταγενέστερη της ημερομηνίας υποβολής της αίτησης."
        )
      )
      .min(
        new Date("01/01/1900"),
        t("Ελέγξτε την ημερομηνία απόφασης οργάνου (έτος 4 ψηφία).")
      ),
    fudocPrakt: yup
      .string()
      .notRequired()
      .test(
        "boardDate-check",
        t(
          "Αν υπάρχει Αρχείο Πρακτικού Είδους Οργάνου απαιτείται η Ημερομηνία απόφασης οργάνου."
        ),
        (value, context) => {
          const { boardDate, fudocPrakt } = context.parent;
          return !(fudocPrakt && !boardDate);
        }
      ),
    url: yup
      .string()
      .test(
        "url2-check",
        t("Πρέπει να συμπληρώσετε τουλάχιστον ένα url."),
        (value, context) => {
          const { url, url2 } = context.parent;
          if (url || url2) return true;
        }
      ),
    url2: yup
      .string()
      .test(
        "url-check",
        t("Πρέπει να συμπληρώσετε τουλάχιστον ένα url."),
        (value, context) => {
          const { url, url2 } = context.parent;
          if (url || url2) return true;
        }
      ),
  });
};
